import mixpanel from 'mixpanel-browser';
import { createContext, useContext } from 'react';
import {
  MixPanelContextData as ContextData,
  MixPanelContextProps as ContextProps,
} from './types';

// const TRACKING_ACTIVE = process.env.NODE_ENV === 'production';
const TRACKING_ACTIVE = false;

const context = createContext<ContextData>({} as ContextData);

const { Provider } = context;

export const useMixPanelContext = () => useContext(context);

export const MixPanelProvider = ({
  children,
  token,
  config,
  projectName,
}: ContextProps) => {
  const instance = TRACKING_ACTIVE
    ? mixpanel.init(
        token,
        { track_pageview: 'url-with-path', ...config },
        projectName
      )
    : undefined;

  return <Provider value={{ mixpanel: instance }}>{children}</Provider>;
};
